export default {
    nav_primary: 10,
    nav_secondary: 5,
    nav_flyover: 15,
    overlay_main: 8
};
